if (!customElements.get('quick-atc-form')) {
    customElements.define(
      'quick-atc-form',
      class QuickAtcForm extends HTMLElement {
        constructor() {
          super();
  
          this.form = this.querySelector('form');
          this.submitButton = this.querySelector('[type="submit"]');
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.form.addEventListener('click', (event) => event.stopPropagation());
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.addedTimeout = null;
        }

        disconnectedCallback() {
          if (this.addedTimeout) window.clearTimeout(this.addedTimeout);
        }

        setState(state) {
          this.classList.toggle('is-loading', state === 'loading');
          this.classList.toggle('is-added', state === 'added');

          if (!this.submitButton) return;

          const busy = state === 'loading';
          this.submitButton.toggleAttribute('aria-disabled', busy);
          this.submitButton.setAttribute('aria-busy', busy ? 'true' : 'false');

          const label =
            state === 'loading'
              ? this.dataset.loadingLabel
              : state === 'added'
                ? this.dataset.addedLabel
                : this.dataset.idleLabel;

          if (label) this.submitButton.setAttribute('aria-label', label);
        }
  
        onSubmitHandler(evt) {
          evt.preventDefault();
          evt.stopPropagation();

          if (this.classList.contains('is-loading')) return;

          if (this.addedTimeout) {
            window.clearTimeout(this.addedTimeout);
            this.addedTimeout = null;
          }

          this.error = false;
          this.setState('loading');
          let added = false;
  
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
  
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
  
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.error = true;
                return;
              }

              added = true;
              const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

              if (added) {
                this.setState('added');
                this.addedTimeout = window.setTimeout(() => this.setState('idle'), 1600);
              } else {
                this.setState('idle');
              }

              CartPerformance.measureFromEvent("add:user-action", evt);
            });
        }
  
        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;
  
          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
  
        toggleSubmitButton(disable = true, text) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
  
        get variantIdInput() {
          return this.form.querySelector('[name=id]');
        }
      }
    );
  }
  